<template>
  <div data-cy="ad-subscription-plan-card">
    <div class="flex justify-between">
      <h1>Hera AI</h1>
    </div>
   
    <!-- UPGRADE CARDS -->
    <transition  mode="out-in">
      <div class="mt-4 grid grid-cols-8 grid-flow-row gap-4">
        <div class="col-span-8 p-4 relative border-2 rounded-lg shadow">
          <div v-if="featurePermissions['featureEnabledVehiclePhotoLogsHeraAi'] || featurePermissions['featureEnabledAmazonChromePlugin'] || featurePermissions['featureEnabledAIChat']">
            <p class="inline-block text-gray-600 text-base font-bold mr-2">Hera AI Settings</p>
            <el-form label-position="top" size="small">
                <p> Using Hera AI, you can unlock deeper insights from your data. To use this service, 
                    we sometimes need to share portions of your data with selected third party vendors, 
                    so additional terms of use apply. View Hera AI's Terms of Use 
                    <a href="https://www.herasolutions.app/hera-ai-supplemental-terms-of-use" target="_blank"> 
                      <i class="uil uil-external-link-alt"></i></a>
                </p>
                <div class="col-span-12 mt-4 md:col-span-6 lg:col-span-4">
                    <div>Enable Hera AI Features</div>
                    <el-switch
                      v-model="HeraAiFeatures"
                      active-color="#13ce66"
                      @change="toggleHeraAiFeatures"
                    >
                    </el-switch>
                </div>
                <div class="col-span-12 mt-2 my-2 md:col-span-6 lg:col-span-4" v-if="HeraAiFeatures && showVehiclePhotoLogsToggle">
                    <div>Enable Hera AI for Vehicle Photo Logs Photo Review</div>
                    <el-switch
                      v-model="HeraAiPhotologReview"
                      active-color="#13ce66"
                      @change="toggleHeraAihotologReview"
                    >
                    </el-switch>
                </div>
                <div class="col-span-12 mt-2 my-2 md:col-span-6 lg:col-span-4" v-if="HeraAiFeatures && showAIChatToggle">
                    <div>Enable Hera AI Chat</div>
                    <el-switch
                      v-model="HeraAiChat"
                      active-color="#13ce66"
                      :disabled="!isAIChatEnabled"
                      @change="toggleHeraAiChat"
                    >
                    </el-switch>
                    <p v-if="!isAIChatEnabled" class="text-xs text-gray-500 mt-1">
                      To enable Hera AI Chat, you'll need to upgrade your plan. Please contact Hera Support by chatting with us below.
                    </p>
                </div>
                <div class="col-span-12 mt-2 my-2 md:col-span-6 lg:col-span-4" v-if="HeraAiFeatures && showAmazonChromePluginToggle">
                    <div>Enable Hera Amazon Chrome Plugin</div>
                    <el-switch
                      v-model="AmazonChromePluginToggle"
                      active-color="#13ce66"
                      :disabled="!isAmazonChromePluginEnabled"
                      @change="toggleAmazonChromePlugin"
                    >
                    </el-switch>
                    <p v-if="!isAmazonChromePluginEnabled" class="text-xs text-gray-500 mt-1">
                      To enable Hera Amazon Chrome Plugin, you'll need to upgrade your plan. Please contact Hera Support by chatting with us below.
                    </p>
                </div>
            </el-form>
          </div>  
          <div v-else>
            <template>
                <h1>Upgrade Required</h1>
                <p>
                  To enable Hera AI features, you'll need to upgrade your plan. Please contact Hera Support by chatting with us below.
                </p>
                
            </template>
          </div>
        </div>
     </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { updateTenantDetail } from '@/store/mutations'
import { getTenantFeaturePermissions } from '@/middlewares/permissions'
import moment from "moment-timezone";
export default {
  name: 'HeraAIIndex',
  data() {
    return {
      HeraAiFeatures: false,
      HeraAiPhotologReview: false,
      HeraAiChat: false,
      AmazonChromePluginToggle: false,
      featurePermissions:{},
    };
  },
  computed: {
    ...mapState(['userInfo']),
        tenant: {
            get(){
                return this.userInfo.tenant
            },
            set(value){
                this.userInfo.tenant = value
            }
        },
      today() {
      return moment.tz(this.timeZone).format();
    },
    timeZone() {
      return this.getTenantTimeZone();
    },
    showVehiclePhotoLogsToggle() {
      return !!this.userInfo.tenant?.featureAccessVehiclePhotoLogsHeraAi && !!this.userInfo.tenant?.featureEnabledVehiclePhotoLogsHeraAi;
    },
    showAmazonChromePluginToggle() {
      return !!this.userInfo.tenant?.featureAccessAmazonChromePlugin;
    },
    isAmazonChromePluginEnabled() {
      return !!this.userInfo.tenant?.featureAccessAmazonChromePlugin && !!this.userInfo.tenant?.featureEnabledAmazonChromePlugin;
    },
    showAIChatToggle() {
      return !!this.userInfo.tenant?.featureAccessAIChat;
    },
    isAIChatEnabled() {
      return !!this.userInfo.tenant?.featureAccessAIChat && !!this.userInfo.tenant?.featureEnabledAIChat;
    },
  },
  beforeMount() {
    this.featurePermissions = getTenantFeaturePermissions()
    // Initialize master toggle from raw tenant permission values (not resolved featurePermissions)
    // so toggles are visible when the DB has them enabled, regardless of featureAccess/featureEnabled gates
    this.HeraAiFeatures = !!(this.userInfo.tenant.permissionVehiclePhotoLogsHeraAi || this.userInfo.tenant.permissionAIChat || this.userInfo.tenant.permissionAmazonChromePlugin)
    this.HeraAiPhotologReview = !!this.userInfo.tenant.permissionVehiclePhotoLogsHeraAi
    this.HeraAiChat = !!this.userInfo.tenant.permissionAIChat
    this.AmazonChromePluginToggle = !!this.userInfo.tenant.permissionAmazonChromePlugin
  },
  mounted() {
     
  },
  methods: {
    changeToggles(){
      this.featurePermissions.permissionVehiclePhotoLogsHeraAi = this.HeraAiPhotologReview 
      this.featurePermissions.permissionHeraAi = this.HeraAiFeatures 
      this.featurePermissions.permissionAIChat = this.HeraAiChat
      this.featurePermissions.permissionAmazonChromePlugin = this.AmazonChromePluginToggle
    },
    async UpdateTenantHeraAI(){
      const updatedAt = this.today
      const input = {
          id: this.tenant.id,
          permissionHeraAi : this.featurePermissions.permissionHeraAi ,
          permissionVehiclePhotoLogsHeraAi : this.featurePermissions.permissionVehiclePhotoLogsHeraAi,
          permissionAIChat: this.HeraAiChat,
          permissionAmazonChromePlugin : this.featurePermissions.permissionAmazonChromePlugin,
          updatedAt: updatedAt
        }
       
       const response = await this.api(updateTenantDetail, {input: input})
       
       // Update local state and Vuex store with response
       if (response.data.updateTenant) {
         // Use the syncCurrentUserTenant action to properly update the store
         this.$store.dispatch('syncCurrentUserTenant', response.data.updateTenant)
         
         // Reload local state from updated store
         this.HeraAiChat = response.data.updateTenant.permissionAIChat
         this.AmazonChromePluginToggle = response.data.updateTenant.permissionAmazonChromePlugin
         this.featurePermissions = getTenantFeaturePermissions()
       }
    },
    async toggleHeraAiFeatures() {
      if (this.HeraAiFeatures) {
        // When turning ON, only enable child toggles if their feature is enabled for the tenant
        this.HeraAiPhotologReview = this.showVehiclePhotoLogsToggle
        this.HeraAiChat = this.isAIChatEnabled
        this.AmazonChromePluginToggle = this.isAmazonChromePluginEnabled
      } else {
        // When turning OFF Hera AI Features, cascade OFF all sub-features
        this.HeraAiPhotologReview = false
        this.HeraAiChat = false
        this.AmazonChromePluginToggle = false
      }
      this.changeToggles()
      await this.UpdateTenantHeraAI()
    },
    async toggleHeraAihotologReview() {
      this.syncParentToggle()
      this.changeToggles()
      await this.UpdateTenantHeraAI()
    },
    async toggleHeraAiChat() {
      this.syncParentToggle()
      this.changeToggles()
      await this.UpdateTenantHeraAI()
    },
    async toggleAmazonChromePlugin() {
      this.syncParentToggle()
      this.changeToggles()
      await this.UpdateTenantHeraAI()
    },
    syncParentToggle() {
      // Sync HeraAiFeatures based on any child being ON
      this.HeraAiFeatures = this.HeraAiPhotologReview || this.HeraAiChat || this.AmazonChromePluginToggle
    },
  },
}
</script>
<style scoped>
  .el-select{
        width: 100%;
  }
  .red-text{
    @apply text-red-600;
  }
  .padding-bottom-1{
    @apply pb-3
  }
.child-view {
  transition: all .5s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
.warning-message{
    word-break:break-word;
}
</style>
